export default __webpack_public_path__ + "7888feee15b3e21e07e7b1c96d0b6c5d.svg";